import { useTranslation } from 'react-i18next';
import { LogIn } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader } from '@/components/ui/card';
import { useAuth } from '@/hooks/useAuth';
import { useSearchParams } from 'react-router-dom';
import { AppIconWithName } from '@/components/ui/icons/AppIconWithName';

export default function LoginPage() {
  const { t } = useTranslation();
  const { login } = useAuth();
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirect');

  const handleLogin = () => {
    login(redirectTo);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Card className="w-full max-w-md">
        <CardHeader className="items-center !pb-0">
          <AppIconWithName />
        </CardHeader>
        <CardContent className="space-y-6 pt-5">
          <CardDescription className="text-center">{t('login.description')}</CardDescription>
          <Button onClick={handleLogin} className="w-full" size="lg">
            <LogIn className="mr-2 h-4 w-4" />
            {t('login.logInWithSalesforce')}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
